/**
 * @description Function that returns the icon name based on the type of the element.
 * @link https://dx.builddesygner.xyz/?path=/story/design-system-atoms-icon--standard-icons
 */
export function getIconName(type) {
    const icons = {
        background: 'editor-images',
        element: 'editor-elements',
        icon: 'editor-elements',
        image: 'editor-images',
        logo: 'editor-my-assets',
        shape: 'editor-elements',
        sticker: 'editor-elements',
        table: 'editor-table',
        text: 'editor-text',
        textIndicator: 'text-indicator',
        vector: 'editor-elements',
        video: 'editor-video',
    };
    if (!type || typeof type !== 'string')
        return icons['element'];
    return icons[type] || icons['element'];
}
//# sourceMappingURL=icons.js.map